<template>
  <picture>
    <source v-if="checkType('avif')" :srcset="getTypeSrc('avif')" type="image/avif">
    <source v-if="checkType('webp')" :srcset="getTypeSrc('webp')" type="image/webp">
    <source v-if="checkType('png')" :srcset="getTypeSrc('png')" type="image/x-png">
    <source v-if="checkType('jpg')" :srcset="getTypeSrc('jpg')" type="image/jpeg">
    <img :src="imgUrl" :alt="alt" :class="classes">
  </picture>
</template>

<script>
export default {
  props: {
    alt: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    src: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    imgUrl() {
      const src = this.src
      if (!src.multiple || !src.multiple.icon) {
        return src.image
      }

      const icon = src.multiple.icon
      if (icon.avif) return icon.avif
      if (icon.webp) return icon.webp
      if (icon.png) return icon.png
      if (icon.jpg) return icon.jpg
      return src.image
    }
  },
  methods: {
    checkType(type) {
      return (this.src.multiple &&
              this.src.multiple.icon &&
              this.src.multiple.icon[type]) || false
    },
    getTypeSrc(type) {
      return (this.src.multiple &&
              this.src.multiple.icon &&
              this.src.multiple.icon[type]) || ''
    }
  }
}
</script>
